<template>
  <div>
    <h2>{{ headerText }}</h2>
    <div class="row">
      <div class="col-md-12 add_top_30">
        <div class="box_general padding_bottom">
          <form autocomplete="off" method="post" class="form-vertical">
            <div class="row">
              <div class="col-md-10">
                <div class="form-group">
                  <label>Search By Merchant (Shop name)</label>
                  <input
                    type="text"
                    v-model="search.company_name"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <button style="margin-top: 34px;padding: 13px 44px;"
                    type="button"
                    @click.prevent="ShowList()"
                    class="btn_1 medium"
                  > Filter
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <table class="table table-striped table-bordered table-sm" cellspacing="0" width="100%" id="offerList">
      <thead>
        <tr>
          <th>Sr No</th>
          <th>Shop</th>
          <th>Category</th>
          <th>Title</th>
          <th>Discount</th>
          <th>Location</th>
          <th>Pincode</th>
          <th>Valid Till</th>
          <th>#</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(offer, index) in offers" :key="offer.id">
          <th>{{ index + 1 }}</th>
          <td>
            {{ offer.company_name }}
          </td>
          <td>
            <div
              v-for="categories in offer.offer_categories"
              :key="categories.id"
            >
               {{ categories.category }},
            </div>
          </td>
          <td>
            {{ offer.short_description }}
          </td>
          <td>
            <span v-if="offer.offer_in == 'percent'"
              >{{ offer.offer_value }}%</span
            >
            <span v-else>{{ offer.offer_value }}</span>
          </td>
          <td>
            {{ offer.location }}
          </td>
          <td>
            {{ offer.pincode }}
          </td>
          <td>
            {{ offer.valid_till }}
          </td>
          <td>
            <a
              :href="'#offer_wishlist_' + offer.id"
              @click="createOfferWishlist(offer.id)"
              :id="'offer_wishlist_' + offer.id"
            >
              <i class="fa fa-heart-o"></i
            ></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
 
<script>
//import "jquery/dist/jquery.min.js";
//import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
//import "datatables.net-dt/css/jquery.dataTables.min.css";
//import axios from "axios";
import $ from "jquery";
import API from "@/services/index.js";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
//$(".table").DataTable();
export default {
  data: function () {
    return {
      dt: null,
      list: [],
      offers: [],
      headerText: "",
      search: {
        is_active: "1",
        company_name: "",
      },
      role_id: localStorage.getItem("role_id"),
      token: localStorage.getItem("token"),
    };
  },
  methods: {
    redirect(offerId) {
      this.$router.push("/viewoffer/" + offerId);
    },
    ShowList: function () {
      //alert(this.search.is_active);
      const token = "Bearer " + localStorage.getItem("token");
      const role_id = localStorage.getItem("role_id");
      const form = new FormData();
      form.append("role_id", role_id);
      form.append("search", JSON.stringify(this.search));
      //var data = { role_id: role_id, search: this.search };
      API.post("offer/get_offer_by_vendorId", form, {
        headers: { Authorization: token },
      })
        .then((response) => {
          this.dt = $(".table").DataTable();

          setTimeout(() => (this.offers = response.data.data));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    createOfferWishlist(offerId) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      const form = new FormData();
      form.append("role_id", this.role_id);
      form.append("offer_id", offerId);
      //var data = { role_id: role_id, search: this.search };
      API.post("offer/addOfferToWishlist", form, {
        headers: { Authorization: "Bearer " + this.token },
      })
        .then((response) => {
          console.log(response.data.data);
          Toast.fire({
            icon: "Success",
            title: response.data.messages,
          });
        })
        .catch((error) => {
          console.log(error);
          Toast.fire({
            icon: "Error",
            title: error.data.messages,
          });
        });
    },
  },
  watch: {
    offers(val) {
      console.log(val);
      this.dt.destroy();

      this.$nextTick(() => {
        this.dt = $(".table").DataTable({
           processing: true,
                dom: 'Bfrtip',
                    buttons: ['copy', 'csv', 'print'
                    ]
        });
        //this.ShowList();
      });
    },
  },
  created() {},
  mounted() {
    this.ShowList();
  },
};
</script>